import React, { useState } from 'react';
import { ChevronIcon } from '@clearcover/atlas';
import Badge from './Badge';
import JsonDiff from './JsonDiff';
import styles from './styles.module.css';

interface DiffItemProps {
  type: 'ADDED' | 'UPDATED' | 'DELETED';
  summary: string;
  old?: Record<string, unknown>;
  new?: Record<string, unknown>;
}

const DiffItem: React.FC<DiffItemProps> = ({
  type,
  summary,
  old: oldVal,
  new: newVal,
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={styles.diffItem}>
      <button
        type="button"
        data-testid={`diff-item-toggle-${summary}`}
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
        className={styles.diffItemButton}
      >
        <Badge type={type} />
        <span className={styles.diffItemSummary}>{summary}</span>
        <ChevronIcon
          aria-hidden="true"
          className={styles.diffItemChevron}
          style={{
            transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)',
            transition: 'transform 0.15s',
            width: 16,
            height: 16,
          }}
        />
      </button>

      {expanded && (
        <div className={styles.diffItemContent}>
          {type === 'UPDATED' && <JsonDiff old={oldVal} new={newVal} />}
          {type === 'ADDED' && <JsonDiff old={undefined} new={newVal} />}
          {type === 'DELETED' && <JsonDiff old={oldVal} new={undefined} />}
        </div>
      )}
    </div>
  );
};

export default DiffItem;
